import { supabase, getSessionSafe } from '../../lib/supabase'

export async function fetchConversationList() {
  const session = await getSessionSafe()
  if (!session) return []
  const { data } = await supabase
    .from('agent_conversations')
    .select('id, created_at, updated_at, messages')
    .eq('user_id', session.user.id)
    .order('updated_at', { ascending: false })
    .limit(50)
  return data || []
}

export async function fetchConversation(convId) {
  const session = await getSessionSafe()
  if (!session) return null
  const { data } = await supabase
    .from('agent_conversations')
    .select('id, messages')
    .eq('id', convId)
    .eq('user_id', session.user.id)
    .single()
  return data
}

export async function deleteConversationRow(convId) {
  const session = await getSessionSafe()
  if (!session) return
  await supabase.from('agent_conversations')
    .delete().eq('id', convId).eq('user_id', session.user.id)
}

export function getConversationPreview(conv, fallback) {
  const msgs = conv.messages || []
  const firstUser = msgs.find(m => m.role === 'user')
  if (firstUser) return firstUser.content.substring(0, 50) + (firstUser.content.length > 50 ? '...' : '')
  return fallback
}

export function formatConvDate(dateStr, lang) {
  const d = new Date(dateStr)
  const now = new Date()
  const isToday = d.toDateString() === now.toDateString()
  const locale = lang === 'it' ? 'it-IT' : 'en-US'
  if (isToday) return d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
  return d.toLocaleDateString(locale, { day: 'numeric', month: 'short' })
}
